import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try { await login(email, password); } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-[1.2fr_1fr] bg-[var(--cream)]">
      <div className="relative hidden lg:block overflow-hidden">
        <img src={`${process.env.REACT_APP_BACKEND_URL}/api/assets/cover.jpg`} alt="" className="absolute inset-0 w-full h-full object-cover scale-105" />
        <div className="absolute left-10 bottom-10 bg-[var(--cream)] px-8 py-6 rise">
          <p className="wordmark text-2xl">JORDYBLUE</p>
          <p className="text-xs tracking-[0.25em] uppercase mt-2 text-[var(--muted-ink)]">Catalog Studio</p>
        </div>
      </div>
      <form onSubmit={submit} className="flex flex-col justify-center px-8 sm:px-16 lg:px-20 py-16 rise" data-testid="login-form">
        <p className="wordmark text-sm lg:hidden mb-10">JORDYBLUE</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight">Sign in</h1>
        <p className="text-sm text-[var(--muted-ink)] mt-3 mb-10 max-w-sm">Build category catalogs, page by page, in the exact Jordyblue layout.</p>
        <label className="text-[11px] tracking-[0.2em] uppercase mb-2">Email</label>
        <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="h-12 bg-transparent mb-6" data-testid="login-email-input" />
        <label className="text-[11px] tracking-[0.2em] uppercase mb-2">Password</label>
        <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="h-12 bg-transparent" data-testid="login-password-input" />
        {error && <p className="text-sm text-red-700 mt-4" data-testid="login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="h-12 mt-8 tracking-[0.2em] uppercase text-xs" data-testid="login-submit-button">
          {busy ? "Signing in…" : "Enter studio"}
        </Button>
      </form>
    </div>
  );
}
